import React from "react";
import { Spinner } from "./Tailwind/Spinner";

import { toast } from "react-toastify";
import { IoCloseCircleOutline } from "react-icons/io5";
import "react-toastify/dist/ReactToastify.css";

interface LoaderProps {
    loading?: boolean;
    error?: string;
}

const Loader: React.FC<LoaderProps> = ({ loading, error }) => {
  const Icon = IoCloseCircleOutline as any;
  return (
      <React.Fragment>
        <div className="flex justify-center mx-2 mt-2">
          {loading ? (
            <Spinner color="primary" />
          ) : (
            <div
              className="flex flex-col items-center justify-center py-12 px-3"
              style={{ fontFamily: "Gmarket-M", color: "var(--color-primary)" }}
            >
              <Icon size={30} color="var(--color-primary)" />
              <p className="my-2">불러올 목록이 없습니다.</p>
            </div>
          )}
        </div>

        {error
          ? (toast.error(error, {
              position: "top-right",
              hideProgressBar: false,
              progress: undefined,
              toastId: "",
            }) as unknown as React.ReactNode)
          : null}
      </React.Fragment>
  );
};

export default Loader;
